import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeUserPassword } from '../../store/slices/settingsSlice';
import Dialog from '../common/Dialog';

const ChangePasswordDialog = ({ user, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const inputClasses = `
    w-full border border-gray-200 px-4 py-2.5 rounded-md
    focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-gray-900
    bg-white transition-colors
  `;

  const labelClasses = "block text-sm font-medium text-gray-700 mb-1";

  const buttonClasses = {
    primary: `px-4 py-2.5 text-sm font-medium text-white bg-blue-600 border border-transparent 
              rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500`,
    secondary: `px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 
                rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500`
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    try {
      await dispatch(changeUserPassword({ userId: user._id, password })).unwrap();
      setPassword('');
      setConfirmPassword('');
      onClose();
    } catch (error) {
      setError(error || 'Failed to change password');
    }
  };

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">
            Change Password for {user?.profile.firstName} {user?.profile.lastName}
          </h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className={labelClasses}>
              New Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputClasses}
              placeholder="Enter new password"
              minLength={8}
              required
            />
          </div>

          <div>
            <label className={labelClasses}>
              Confirm Password
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className={inputClasses}
              placeholder="Confirm new password"
              minLength={8}
              required
            />
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className={buttonClasses.secondary}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={buttonClasses.primary}
            >
              Change Password
            </button>
          </div>
        </form>
      </div>
    </Dialog>
  );
};

export default ChangePasswordDialog; 